import { InjectionToken } from '@angular/core';

export const ValueMinerAPIUrl = new InjectionToken('ValueMinerAPIUrl');
export const ValueMinerMessagingAPIUrl = new InjectionToken('ValueMinerMessagingAPIUrl');
export const ValueMinerExportAPIUrl = new InjectionToken('ValueMinerExportAPIUrl');
export const ValueMinerOAuthUrl = new InjectionToken('ValueMinerOAuthUrl');
export const ValueMinerGoUrl = new InjectionToken('ValueMinerGoUrl');
